import React, { useState, useEffect } from "react";
import { Tag, Classes, Button, Icon, FormGroup, ControlGroup, InputGroup, Dialog, Tooltip } from "@blueprintjs/core";
import { Trans } from 'react-i18next';
import { authenticatedPostFetch, authenticatedGetFetch, authenticatedDeleteFetch } from "../../utils/AuthenticatedFetch";

export default function Trunk(props) {
    const [Open, setOpen] = useState(false);
    const [Id, setId] = useState(undefined);
    const [Contact, setContact] = useState(undefined);
    const [Username, setUsername] = useState(undefined);
    const [Password, setPassword] = useState(undefined);
    const [CompleteTrunk, setCompleteTrunk] = useState(true);
    const [Confirm, setConfirm] = useState(false);

    useEffect(() => {
        if (Confirm) {
            if (Contact === undefined || Contact.trim().length === 0 || Username === undefined || Username.trim().length === 0 || Password === undefined || Password.trim().length === 0)
                setCompleteTrunk(false)
            else {
                setCompleteTrunk(true)
                authenticatedPostFetch("/phonie/trunk", { 
                    contact: Contact,
                    username: Username,
                    password: Password
                }, () => { setOpen(false); props.update(true) });
            }
            setConfirm(false)
        }
    }, [Confirm])

    return (<div>
        <Tag
            large={true}
            round={true}
            icon="antenna"
            interactive={true}
            onClick={() => {
                setOpen(true);
                authenticatedGetFetch('/phonie/trunk',
                    (trunk) => {
                        setId(trunk.id)
                        setContact(trunk.contact);
                        setUsername(trunk.username);
                        setPassword(trunk.password);
                    });

            }} />
        <Dialog
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            icon="antenna"
            isOpen={Open}
            isCloseButtonShown={true}
            onClose={() => {
                setOpen(false);
                setContact(undefined);
                setUsername(undefined);
                setPassword(undefined);
            }}
            title={"Trunk"}>
            <div className={Classes.DIALOG_BODY}>
                <FormGroup label={<Trans>contact</Trans>} labelFor="name-input">
                    <ControlGroup fill={true} >
                        <InputGroup
                            id="name-input"
                            onChange={(contact) => setContact(contact.target.value)}
                            leftIcon="at"
                            large={true}
                            intent={"primary"}
                            placeholder="sbc8.fr.sip.ovh"
                            defaultValue={Contact}
                        />
                        <Tooltip content={<Trans>contact associated with the ovh account</Trans>}>
                            <Icon icon="info-sign" intent="primary" />
                        </Tooltip>
                    </ControlGroup>
                </FormGroup>
                <FormGroup label={<Trans>username</Trans>} labelFor="name-input">
                    <ControlGroup fill={true} >
                        <InputGroup
                            id="name-input"
                            onChange={(username) => setUsername(username.target.value)}
                            leftIcon="sim-card"
                            large={true}
                            intent={"primary"}
                            placeholder="0033972452966"
                            defaultValue={Username}
                        />
                        <Tooltip content={<Trans>username associated with the ovh account</Trans>}>
                            <Icon icon="info-sign" intent="primary" />
                        </Tooltip>
                    </ControlGroup>
                </FormGroup>
                <FormGroup label={<Trans>password</Trans>} labelFor="password-input">
                    <ControlGroup fill={true} >
                        <InputGroup
                            id="password-input"
                            onChange={(password) => setPassword(password.target.value)}
                            leftIcon="lock"
                            large={true}
                            intent={"primary"} />
                        <Tooltip content={<Trans>password associated with the ovh account</Trans>}>
                            <Icon icon="info-sign" intent="primary" />
                        </Tooltip>
                    </ControlGroup>
                </FormGroup>
            </div>
            <div className="flexbox-center-center">
                <FormGroup >
                    <Button
                        intent="success"
                        onClick={() => setConfirm(true)}
                    >
                        <Trans>confirm</Trans>
                    </Button>
                </FormGroup>
                <FormGroup >
                    <Button
                        intent="danger"
                        text={<Trans>remove</Trans>}
                        disabled={Id == undefined}
                        onClick={() => {
                            authenticatedDeleteFetch("/phonie/trunk",
                                { id: Id },
                                () => {
                                    setId(undefined);
                                    setOpen(false);
                                    setUsername(undefined);
                                    setContact(undefined);
                                    setPassword(undefined);
                                    props.update(false)
                                });
                        }}
                    />
                </FormGroup>
            </div>
            {(!CompleteTrunk) &&
                <Tag
                    large={true}
                    intent="warning"
                    icon="warning-sign">
                    <Trans>please fill in the fields above before validating</Trans></Tag>}
        </Dialog>
    </div>
    )
}